import type { PricePosition } from '../api/types';
import { POSITION_COLOR, POSITION_LABEL } from '../charts/palette';

import { Badge } from './Badge';

export function PositionBadge({ position }: { position: PricePosition }) {
  return <Badge label={POSITION_LABEL[position]} color={POSITION_COLOR[position]} />;
}
